import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/user/home/home_list_ico1.png'
import _imports_1 from '@/assets/user/home/home_list_ico2.png'
import _imports_2 from '@/assets/user/home/home_btn_list_ico1.png'
import _imports_3 from '@/assets/user/home/home_btn_list_ico2.png'
import _imports_4 from '@/assets/user/home/home_btn_list_ico3.png'
import _imports_5 from '@/assets/user/home/home_btn_list_ico4.png'
import _imports_6 from '@/assets/user/home/home_btn_list_ico5.png'
import _imports_7 from '@/assets/user/home/home_btn_list_ico6.png'
import _imports_8 from '@/assets/user/home/home_btn_list_ico7.png'
import _imports_9 from '@/assets/user/home/form_ico.png'
import _imports_10 from '@/assets/user/home/form_go_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-acb4a3fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "home_layout" }
const _hoisted_5 = { class: "home_lists" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Stress"),
    /*#__PURE__*/_createElementVNode("p", null, "스트레스")
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "point"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "point"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Fatigability"),
    /*#__PURE__*/_createElementVNode("p", null, "피로도")
  ])
], -1))
const _hoisted_12 = {
  key: 0,
  class: "point"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "point"
}
const _hoisted_16 = { class: "home_btn_lists" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "preEB" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("혈압(수축기)")
], -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "preEB" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("혈압(이완기)")
], -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "preEB" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("심박수")
], -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "preEB" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("체온")
], -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "preEB" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("산소포화도")
], -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "preEB" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("체중")
], -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "preEB" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("골격근량")
], -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "preEB" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preEB" }, "-", -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("체지방률")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 설문조사 ")
], -1))
const _hoisted_66 = { class: "preEB" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_section_tit" }, "커뮤니티", -1))
const _hoisted_69 = { class: "home_board" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "title" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mainNotice" }, "공지", -1))
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "title" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = { class: "date" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_section_tit" }, "스트레스 케어", -1))
const _hoisted_79 = { class: "home_gallery" }
const _hoisted_80 = { class: "thumb" }
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "title" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_section_tit" }, "경찰청 Youtube", -1))
const _hoisted_84 = { class: "home_youtube" }
const _hoisted_85 = { class: "video" }
const _hoisted_86 = ["src"]
const _hoisted_87 = { class: "video_bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTitleHealthDetail('stress')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    ($setup.health.stress === null || $setup.health.stress === undefined)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9))
                      : (_openBlock(), _createElementBlock("p", _hoisted_10, [
                          _createElementVNode("span", null, _toDisplayString($setup.health.stress), 1),
                          _createTextVNode("점 ")
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTitleHealthDetail('fatigue')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    ($setup.health.fatigue === null || $setup.health.fatigue === undefined)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_14))
                      : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString($setup.health.fatigue), 1),
                          _createTextVNode("점 ")
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goDetailHealth('diastole')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.diastole)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString($setup.health.diastole), 1),
                          _createTextVNode("mmHg ")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_19, _hoisted_21)),
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goDetailHealth('systole')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.systole)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString($setup.health.systole), 1),
                          _createTextVNode("mmHg")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_25, _hoisted_27)),
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goDetailHealth('bitHeart')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.bitHeart)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString($setup.health.bitHeart), 1),
                          _createTextVNode("bpm")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_31, _hoisted_33)),
                    _hoisted_34
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goDetailHealth('temperature')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.temperature)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString($setup.health.temperature), 1),
                          _createTextVNode("˚C")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_37, _hoisted_39)),
                    _hoisted_40
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.goDetailHealth('spO2')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.spO2)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString($setup.health.spO2), 1),
                          _createTextVNode("%")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_43, _hoisted_45)),
                    _hoisted_46
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.goDetailHealth('weight')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.weight)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString($setup.health.weight), 1),
                          _createTextVNode("kg")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_49, _hoisted_51)),
                    _hoisted_52
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.goDetailHealth('muscleMass')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.muscleMass)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString($setup.floatFormat($setup.health.muscleMass)), 1),
                          _createTextVNode("kg ")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_55, _hoisted_57)),
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "#",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.goDetailHealth('fatRatio')))
                }, {
                  default: _withCtx(() => [
                    ($setup.health.fatRatio)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_59, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString($setup.floatFormat($setup.health.fatRatio) || "-"), 1),
                          _createTextVNode("% ")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_61, _hoisted_63)),
                    _hoisted_64
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: "#",
                class: "home_form_btn",
                onClick: $setup.checkCntSurvey
              }, {
                default: _withCtx(() => [
                  _hoisted_65,
                  _createElementVNode("span", null, [
                    _createElementVNode("b", _hoisted_66, _toDisplayString($setup.state.cntSurvey), 1),
                    _createTextVNode("건 "),
                    _hoisted_67
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_68,
              _createElementVNode("ul", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.community.content, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (item.isImportant === 1)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_70, [
                          _createVNode(_component_router_link, {
                            to: "#",
                            onClick: ($event: any) => ($setup.goCommunity(item.idx))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("span", {
                                  innerHTML: item.title
                                }, null, 8, _hoisted_73)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.community.content, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (item.isImportant === 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_74, [
                          _createVNode(_component_router_link, {
                            to: "#",
                            onClick: ($event: any) => ($setup.goCommunity(item.idx))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_75, [
                                _createElementVNode("p", {
                                  innerHTML: item.title
                                }, null, 8, _hoisted_76)
                              ]),
                              _createElementVNode("span", _hoisted_77, _toDisplayString($setup.formatDate(item.createDate)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_78,
              _createElementVNode("ul", _hoisted_79, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stressCare.content, (item) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createVNode(_component_router_link, {
                      to: "#",
                      onClick: ($event: any) => ($setup.goStressCare(item.idx))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("img", {
                            src: item.thumbnail,
                            alt: ""
                          }, null, 8, _hoisted_81)
                        ]),
                        _createElementVNode("div", _hoisted_82, _toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_83,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.youtube.content, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("iframe", {
                      width: "100%",
                      height: "100%",
                      src: item.youtubeLink,
                      frameborder: "0",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_86)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("p", null, _toDisplayString(item.title), 1)
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "no", "content", "onClose"])
  ], 64))
}